import { createApp } from "vue";

import DialogView from "./DialogView.vue";
import LoadingView from "./LoadingView.vue";
import $ from "jquery";
const dialog = {
  dialog: null,
  Loading: null,
  install(Vue: any) {
    if (this.dialog) {
      Vue.config.globalProperties.showModel = this.dialog.showModel;
    } else {
      const instance = createApp(DialogView);
      instance.use({
        install: function (Vue, options) {
          Vue.config.globalProperties.$jQuery = $;
        },
      });
      const parent = document.createElement("div");
      const bodyDom = document.body;
      bodyDom.appendChild(parent);
      this.dialog = instance.mount(parent);
      Vue.config.globalProperties.showModel = this.dialog.showModel;
    }

    if (this.Loading) {
      Vue.config.globalProperties.showLoading = this.dialog.showLoading;
    } else {
      const instance = createApp(LoadingView);
      instance.use({
        install: function (Vue, options) {
          Vue.config.globalProperties.$jQuery = $;
        },
      });
      const parent = document.createElement("div");
      const bodyDom = document.body;
      bodyDom.appendChild(parent);
      this.Loading = instance.mount(parent);
      Vue.config.globalProperties.showLoading = this.Loading.showLoading;
    }
  },
};
export default dialog;
